// OobmPage.js
import React, { useEffect, useState, useRef,useMemo} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Col, Container, Row, TabContent, Button,
  Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import OobmDevices from './OobmDevices';
import OobmFilterBar from './OobmFilterBar';
import './index.css';
import { getOobmBox } from '../../actions/Oobm';
import { getUsersOobm,assignUsersOobm } from '../../actions/Users';
import Pagination from 'rc-pagination';
import { ENG_LOCALE } from '../../lib/constants';
import SetLimitEntries from '../../components/SetLimitEntries';
import {getUserData} from '../../actions/User';
const FIELD_TO_PARAM = {
  'Serial Number': 'serialnumber',
  'Device Name': 'deviceName',
  'BTN': 'number',
};

export default function OobmPage() {
  const dispatch = useDispatch();
  const token = localStorage.getItem('jwtToken') || null;
  const user = useSelector(state => state.AppState.user);
  // server data
  const [boxData, setBoxData] = useState({
    data: [],
    page: 1,
    limit: 10,
    totalPages: 0,
    totalDocs: 0,
  });

  const [showDlg, setShowDlg] = useState(false);
  const [pickedUsers, setPickedUsers] = useState([]);
  const [userChoices, setUserChoices] = useState([]);
  const [pager, setPager] = useState({ page: 1, limit: 10 });
  const [isLoadingUsers, setIsLoadingUsers] = useState(false);
  const [chosenOobms, setChosenOobms] = useState([]);

  const usersPageRef = useRef(1);
  const loadedPagesRef = useRef(new Set());
  const [field, setField] = useState('Serial Number');
  const [text, setText] = useState('');
  const [serverFilter, setServerFilter] = useState({});
  const [getUser, setGetUser] = useState('');

  useEffect(() => {
    (async () => {
      if (!token) return;
      const res = await dispatch(getOobmBox(token, pager, serverFilter));
      setBoxData(res);
      const userGet=await dispatch(getUserData(token))
      setGetUser(userGet)
    })();
  }, [dispatch, token, pager, serverFilter]);

  const handleChangePagination = (page) => setPager((p) => ({ ...p, page }));
  const handleSetLimit = (lim) => setPager({ page: 1, limit: lim });
  const filteredBoxData = useMemo(() => {
    return boxData;
  }, [boxData]);

const handleValueChange = (v) => {
  setText(v);
  if (v.trim() === '') {
    setServerFilter({});
    setPager(p => ({ ...p, page: 1 }));
  }
};
  const onSearch = () => {
    const key = FIELD_TO_PARAM[field];
    const val = (text || '').trim();
    const nextFilter = !val ? {} : { [key]: val };
    setServerFilter(nextFilter);
    setPager((p) => ({ ...p, page: 1 }));
  };

  const onFilterKeyDown = (e) => {
    if (e.key === 'Enter') onSearch();
  };

  const mergeUniqueByValue = (prev, next) => {
    const map = new Map(prev.map(o => [o.value, o]));
    next.forEach(o => {
      if (o.value && !map.has(o.value)) map.set(o.value, o);
    });
    return Array.from(map.values());
  };

  const fetchUsersPage = async page => {
    if (isLoadingUsers) return;
    if (loadedPagesRef.current.has(page)) return;
    setIsLoadingUsers(true);
    try {
      const res = await dispatch(getUsersOobm(token, { page, limit: 10 }));
      const opts = res.map(u => ({
        value: u?._id || '',
        label: u?.email || ''
      }));
      setUserChoices(prev => mergeUniqueByValue(prev, opts));
      loadedPagesRef.current.add(page);
      usersPageRef.current = page;
    } catch (e) {
      console.log('Failed to load users');
    }
    setIsLoadingUsers(false);
  };

  const openDlg = async () => {
    setUserChoices([]);
    setPickedUsers([]);
    usersPageRef.current = 1;
    loadedPagesRef.current = new Set();
    setShowDlg(true);
    await fetchUsersPage(1);
  };

  const handleAssign = async () => {
    try {
      const oobIds = chosenOobms.map(d => d.linkedNumber?._id).filter(Boolean);
      const payload = pickedUsers.map(x => ({ user: x.value, oobs: oobIds }));
      const res = await dispatch(assignUsersOobm(token, payload));
      if (res) {
        toast.success('Users assigned successfully!');
        setShowDlg(false);
      }
      setPickedUsers([]);
      setChosenOobms([]);
    } catch (e) {
      console.error('Assignment failed:', e);
      toast.error('Failed to assign users.');
    }
  };

  return (
    <>
      <div className="oobm-filter-header">
        <div className="oobm-filter-strip">
          <OobmFilterBar
            field={field}
            value={text}
            onChangeValue={handleValueChange}
            onChangeField={setField}
            // onChangeValue={setText}
            onSearch={onSearch}
            onKeyDown={onFilterKeyDown}
          />
        </div>
      </div>

      {chosenOobms.length > 0 && (
        <Button color="primary" onClick={openDlg} className="mb-2">
          Assign User
        </Button>
      )}

      <Container fluid style={{ margin: 0 }}>
        <div className="viewContainer" style={{ marginTop: '20px' }}>
          <Row>
            <Col md="12">
              <TabContent>
                <OobmDevices
                  user={getUser ? getUser : user}
                  OobmData={filteredBoxData}
                  selectedRows={chosenOobms}
                  setSelectedRows={setChosenOobms}
                />
              </TabContent>
            </Col>
          </Row>

          <Row className="justify-content-center mt-3">
            <Col md="auto" className="d-flex align-items-center gap-3">
              <SetLimitEntries onChange={handleSetLimit} />
              {boxData.totalPages >= 1 && (
                <Pagination
                  locale={ENG_LOCALE}
                  className="pagination-container"
                  onChange={handleChangePagination}
                  current={boxData.page}
                  total={boxData.totalDocs}
                  pageSize={boxData.limit}
                  showLessItems
                  showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
                />
              )}
            </Col>
          </Row>
        </div>
      </Container>

      {/* Assign Users modal */}
      <Modal isOpen={showDlg} toggle={() => setShowDlg(false)} size="lg" backdrop="static" keyboard={false}>
        <ModalHeader toggle={() => setShowDlg(false)}>Assign to Users</ModalHeader>
        <ModalBody style={{ maxHeight: '600px', overflowY: 'auto' }}>
          <b>
            <label>Select User Emails:</label>
          </b>
          <Select
            isMulti
            options={userChoices}
            value={pickedUsers}
            onChange={setPickedUsers}
            placeholder="Choose users"
            classNamePrefix="react-select"
            menuPortalTarget={document.body}
            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
            isLoading={isLoadingUsers}
            onMenuScrollToBottom={async () => {
              const nextPage = usersPageRef.current + 1;
              await fetchUsersPage(nextPage);
            }}
          />

          <b>
            <label>Selected OOBM Numbers:</label>
          </b>
          <ul>
            {chosenOobms.map(obj => (
              <li key={obj._id}>{obj.linkedNumber?.number}</li>
            ))}
          </ul>
          {isLoadingUsers && <div className="text-muted">Loading more users</div>}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleAssign}>Assign</Button>
          <Button
            color="secondary"
            onClick={() => {
              setShowDlg(false);
              setPickedUsers([]);
              setChosenOobms([]);
            }}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}